"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelBreadcrumb = void 0;
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var react_1 = __importDefault(require("react"));
var ChipBreadcrumb_1 = __importDefault(require("./ChipBreadcrumb"));
function LevelBreadcrumb(_a) {
    var items = _a.items, onSelect = _a.onSelect, icon = _a.icon, item = _a.item;
    var _b = __read(react_1.default.useState(undefined), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var openMenu = function (e) {
        setAnchorEl(e.target);
    };
    var closeMenu = function () {
        setAnchorEl(undefined);
    };
    var selectMenuItem = function (selectedItem) {
        closeMenu();
        onSelect(selectedItem);
    };
    var handleListKeyDown = function (e) {
        if (e.key === 'Tab') {
            e.preventDefault();
            closeMenu();
        }
        else if (e.key === 'Escape') {
            closeMenu();
        }
    };
    return (items === null || items === void 0 ? void 0 : items.length) ? (react_1.default.createElement("div", { style: { position: 'relative' } },
        react_1.default.createElement(ChipBreadcrumb_1.default, { icon: icon, label: item, onClick: function () { return onSelect(item); }, deleteIcon: react_1.default.createElement(ExpandMore_1.default, null), onDelete: openMenu, "aria-controls": "basic-menu", "aria-haspopup": "true", "aria-expanded": anchorEl ? 'true' : undefined }),
        react_1.default.createElement(material_1.Popper, { open: Boolean(anchorEl), role: undefined, anchorEl: anchorEl, placement: "bottom" },
            react_1.default.createElement(material_1.Paper, null,
                react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: closeMenu },
                    react_1.default.createElement(material_1.MenuList, { dense: true, autoFocusItem: Boolean(anchorEl), onKeyDown: handleListKeyDown }, items === null || items === void 0 ? void 0 : items.map(function (listItem) { return (react_1.default.createElement(material_1.MenuItem, { key: listItem, onClick: function () { return selectMenuItem(listItem); } }, listItem)); }))))))) : (react_1.default.createElement(ChipBreadcrumb_1.default, { icon: icon, label: item, onClick: function () { return onSelect(item); } }));
}
exports.LevelBreadcrumb = LevelBreadcrumb;
LevelBreadcrumb.defaultProps = {
    icon: undefined,
    items: [],
};
